import { useMutation } from 'react-query';
import axios from 'axios';

import { CreateTemplateDetails } from '@/models/TemplateDetails';
import { useAuth } from '@/modules/Auth/hooks/useAuth';
import { AwsConfigApiGateway } from '@/utils/config/api';

async function createTemplate(data: CreateTemplateDetails, token: string | undefined) {
  const response = await axios.post<CreateTemplateDetails>(
    `${AwsConfigApiGateway.pooledTenantApiUrl}/templates`,
    data,
    {
      headers: {
        'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
        Authorization: 'Bearer ' + token,
      },
    },
  );
  return response.data;
}

export function useCreateTemplate() {
  const { user } = useAuth();
  return useMutation<CreateTemplateDetails, Error, CreateTemplateDetails>((data) =>
    createTemplate(data, user?.signInUserSession.idToken.jwtToken),
  );
}
